import React from 'react';
import { motion } from 'framer-motion';
import { pillars } from '../data/content';
import { Eyebrow, Heading, Section } from './Primitives';
export function Pillars() {
  return <Section id="inside" className="bg-white" ariaLabel="What's inside" data-id="element-154" data-mp="2jaqqm8phwyw6">
      <div className="mx-auto max-w-xl text-center" data-id="element-155" data-mp="2j8nt73m0k3hf">
        <Eyebrow data-id="element-156" data-mp="2o1qszthdw962">One app, everything covered</Eyebrow>
        <Heading data-id="element-157" data-mp="2o3blzeo1vk1t">Built around 4 things every dog owner needs.</Heading>
      </div>

      <div className="mt-11 grid gap-4 sm:grid-cols-2" data-id="element-158" data-mp="2t0afbuzw3myy">
        {pillars.map((pillar, index) => <motion.article key={pillar.title} initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.4,
        delay: index * 0.07,
        ease: 'easeOut'
      }} className="rounded-2xl border border-orangey-100 bg-cream p-6 shadow-soft transition-shadow duration-200 hover:shadow-card sm:p-7" data-id="element-159" data-mp="2xxttyw0i21rf" data-mpi={index}>
            <span aria-hidden="true" className={`flex h-12 w-12 items-center justify-center rounded-xl text-2xl ${pillar.accent}`} data-id="element-160" data-mp="1163tcq5izpc2">
              {pillar.emoji}
            </span>
            <h3 className="mt-4 font-display text-2xl font-extrabold text-ink-900" data-id="element-161" data-mp="sd8s07j6idrk">{pillar.title}</h3>
            <p className="mt-2 leading-relaxed text-ink-500" data-id="element-162" data-mp="ng0bebdoihsf">{pillar.body}</p>
          </motion.article>)}
      </div>
    </Section>;
}